import { render, staticRenderFns } from "./share-icon.vue?vue&type=template&id=20bfa30f&scoped=true&"
import script from "./share-icon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./share-icon.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./share-icon.vue?vue&type=style&index=0&id=20bfa30f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bfa30f",
  null
  
)

export default component.exports